// extracted by mini-css-extract-plugin
export default {"summary":"styles_summary__0f6lp","address":"styles_address__2dBLP","header":"styles_header__KsT4Q","cartItems":"styles_cartItems__ZC41L"};